module.exports = __webpack_public_path__ + "static/header-solutions-bf05b7d12aa7c654088dc4af3b042bfd.svg";